function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.41,
    height: 18.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0283333333333338
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 9.085,
    fontFamily: "Arial"
  }, "\n        Vinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.17,
    width: 28.41,
    height: 20.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.008
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 28.19,
    fontFamily: "Arial"
  }, "\n        Noble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38.21,
    width: 28.41,
    height: 20.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 48.480000000000004,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.75,
    width: 28.41,
    height: 23.69,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9483333333333337
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 70.595,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.44,
    width: 28.41,
    height: 24.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.10625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 94.865,
    fontFamily: "Arial"
  }, "\n        Harrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107.29,
    width: 28.41,
    height: 30.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.55125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 122.43,
    fontFamily: "Arial"
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 137.57,
    width: 28.41,
    height: 33.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.682
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 154.075,
    fontFamily: "Arial"
  }, "\n        Meigs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 170.58,
    width: 28.41,
    height: 33.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 187.5,
    fontFamily: "Arial"
  }, "\n        Wyandot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204.42,
    width: 28.41,
    height: 34.39,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 221.61499999999998,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 238.81,
    width: 28.41,
    height: 36.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 256.825,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 274.84,
    width: 28.41,
    height: 36.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.682
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 293.22999999999996,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 311.62,
    width: 28.41,
    height: 38.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 330.89,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 350.16,
    width: 28.41,
    height: 40.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.058571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 370.38500000000005,
    fontFamily: "Arial"
  }, "\n        Hocking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 390.61,
    width: 28.41,
    height: 41.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 411.13,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 431.65,
    width: 28.41,
    height: 42.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 453.09,
    fontFamily: "Arial"
  }, "\n        Gallia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 474.54,
    width: 28.41,
    height: 43.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.058571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 496.165,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 517.79,
    width: 28.41,
    height: 43.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.058571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 539.755,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 561.72,
    width: 28.41,
    height: 45.44,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.55125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 584.44,
    fontFamily: "Arial"
  }, "\n        Van_Wert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 607.16,
    width: 28.41,
    height: 46.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.682
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 630.305,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 653.45,
    width: 28.41,
    height: 46.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.682
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.205,
    y: 676.725,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 0,
    width: 35.65,
    height: 39.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.941666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.235,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Morrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.06,
    y: 0,
    width: 37.78,
    height: 39.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.197777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.95,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Coshocton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.84,
    y: 0,
    width: 37.98,
    height: 39.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.425714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.83,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 0,
    width: 38.95,
    height: 39.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.86875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.295,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Guernsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.77,
    y: 0,
    width: 40.2,
    height: 39.88,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6971428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.87,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.97,
    y: 0,
    width: 40.35,
    height: 39.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.985
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.145,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.32,
    y: 0,
    width: 40.43,
    height: 39.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.985
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.53499999999997,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Defiance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.75,
    y: 0,
    width: 40.69,
    height: 39.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.985
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.095,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Williams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 0,
    width: 40.99,
    height: 39.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.431111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.935,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.44,
    y: 0,
    width: 41.15,
    height: 39.88,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.646666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.015,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.59,
    y: 0,
    width: 43.43,
    height: 39.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.976000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.30499999999995,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.02,
    y: 0,
    width: 45.61,
    height: 39.88,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.646666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.825,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.63,
    y: 0,
    width: 46.13,
    height: 39.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.646666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.695,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Preble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.75,
    y: 0,
    width: 46.72,
    height: 39.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.976000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.11,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.47,
    y: 0,
    width: 47.6,
    height: 39.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.985
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.27,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 652.07,
    y: 0,
    width: 47.93,
    height: 39.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.646666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.0350000000001,
    y: 19.94,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 39.88,
    width: 47.69,
    height: 41.32,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.264
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 60.540000000000006,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 81.2,
    width: 47.69,
    height: 41.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 102.06,
    fontFamily: "Arial"
  }, "\n        Pickaway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 122.92,
    width: 47.69,
    height: 41.73,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.954999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 143.785,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 164.65,
    width: 47.69,
    height: 42.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 185.68,
    fontFamily: "Arial"
  }, "\n        Auglaize\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 206.71,
    width: 47.69,
    height: 42.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.078333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 227.945,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 249.18,
    width: 47.69,
    height: 45.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.515714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 271.985,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 294.78,
    width: 47.69,
    height: 46.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.331999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 318.10999999999996,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 341.45,
    width: 47.69,
    height: 48.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.538
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 365.46999999999997,
    fontFamily: "Arial"
  }, "\n        Darke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 389.49,
    width: 47.69,
    height: 49.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.948333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 414.13,
    fontFamily: "Arial"
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 438.77,
    width: 47.69,
    height: 49.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.9225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 463.46,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 488.15,
    width: 47.69,
    height: 50.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.96125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 513.4449999999999,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 538.75,
    width: 47.69,
    height: 52.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.96125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 565.235,
    fontFamily: "Arial"
  }, "\n        Sandusky\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 591.72,
    width: 47.69,
    height: 53.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.948333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 618.4300000000001,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 645.14,
    width: 47.69,
    height: 54.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.948333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.254999999999995,
    y: 672.5699999999999,
    fontFamily: "Arial"
  }, "\n        Athens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 39.88,
    width: 45,
    height: 58.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.59,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.1,
    y: 39.88,
    width: 47.17,
    height: 58.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.7925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.685,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Ross\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.26,
    y: 39.88,
    width: 49.63,
    height: 58.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.090000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.075,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Belmont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.89,
    y: 39.88,
    width: 52.43,
    height: 58.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.105,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Scioto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.32,
    y: 39.88,
    width: 53.05,
    height: 58.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.578571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.84499999999997,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.37,
    y: 39.88,
    width: 54.17,
    height: 58.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.018888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.455,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.54,
    y: 39.88,
    width: 57.88,
    height: 58.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.431111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.48,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Muskingum\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.42,
    y: 39.88,
    width: 59.7,
    height: 58.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.27000000000004,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.12,
    y: 39.88,
    width: 63.9,
    height: 58.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 527.07,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Tuscarawas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.02,
    y: 39.88,
    width: 67.63,
    height: 58.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.495555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 592.835,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Ashtabula\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 626.64,
    y: 39.88,
    width: 73.36,
    height: 58.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.3199999999999,
    y: 69.11,
    fontFamily: "Arial"
  }, "\n        Allen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 98.34,
    width: 67.35,
    height: 63.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3950000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.765,
    y: 130.315,
    fontFamily: "Arial"
  }, "\n        Columbiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 162.29,
    width: 67.35,
    height: 65.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.868333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.765,
    y: 194.89499999999998,
    fontFamily: "Arial"
  }, "\n        Geauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 227.5,
    width: 67.35,
    height: 66.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.384
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.765,
    y: 260.96,
    fontFamily: "Arial"
  }, "\n        Miami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 294.42,
    width: 67.35,
    height: 67.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.406
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.765,
    y: 327.935,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 361.45,
    width: 67.35,
    height: 79.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.41875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.765,
    y: 401.425,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 441.39,
    width: 67.35,
    height: 81.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.8375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.765,
    y: 482.335,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 523.29,
    width: 67.35,
    height: 87.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4833333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.765,
    y: 567.17,
    fontFamily: "Arial"
  }, "\n        Fairfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 611.05,
    width: 67.35,
    height: 88.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.469999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.765,
    y: 655.525,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.44,
    y: 98.34,
    width: 73.02,
    height: 91.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.43142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.95,
    y: 144.035,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.46,
    y: 98.34,
    width: 75.53,
    height: 91.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.588333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.22500000000002,
    y: 144.035,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 98.34,
    width: 75.66,
    height: 91.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.808571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.83,
    y: 144.035,
    fontFamily: "Arial"
  }, "\n        Licking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.66,
    y: 98.34,
    width: 76.65,
    height: 91.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.985,
    y: 144.035,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 444.31,
    y: 98.34,
    width: 80.86,
    height: 91.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.476666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.74,
    y: 144.035,
    fontFamily: "Arial"
  }, "\n        Medina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.18,
    y: 98.34,
    width: 84.87,
    height: 91.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.60875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.615,
    y: 144.035,
    fontFamily: "Arial"
  }, "\n        Clermont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610.04,
    y: 98.34,
    width: 89.96,
    height: 91.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.993333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.02,
    y: 144.035,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.44,
    y: 189.73,
    width: 114.39,
    height: 82.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.635,
    y: 230.885,
    fontFamily: "Arial"
  }, "\n        Trumbull\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.44,
    y: 272.04,
    width: 114.39,
    height: 92.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.635,
    y: 318.40000000000003,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.44,
    y: 364.76,
    width: 114.39,
    height: 101.15,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.64375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.635,
    y: 415.335,
    fontFamily: "Arial"
  }, "\n        Mahoning\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.44,
    y: 465.91,
    width: 114.39,
    height: 107.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.853333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.635,
    y: 519.47,
    fontFamily: "Arial"
  }, "\n        Lorain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.44,
    y: 573.03,
    width: 114.39,
    height: 126.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.635,
    y: 636.515,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.83,
    y: 189.73,
    width: 121.61,
    height: 134.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.635,
    y: 257.19,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.45,
    y: 189.73,
    width: 142.24,
    height: 134.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.983999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.57,
    y: 257.19,
    fontFamily: "Arial"
  }, "\n        Lucas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.69,
    y: 189.73,
    width: 178.31,
    height: 134.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.486666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.845,
    y: 257.19,
    fontFamily: "Arial"
  }, "\n        Summit\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.83,
    y: 324.65,
    width: 163.91,
    height: 150.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.011000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.78499999999997,
    y: 399.705,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.83,
    y: 474.76,
    width: 163.91,
    height: 225.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.48875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.78499999999997,
    y: 587.38,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.74,
    y: 324.65,
    width: 278.26,
    height: 164.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.56625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.87,
    y: 406.91499999999996,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.74,
    y: 489.18,
    width: 278.26,
    height: 210.82,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.3525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.87,
    y: 594.59,
    fontFamily: "Arial"
  }, "\n        Cuyahoga\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2004);
export default __webpack_public_path__ + "static/media/2004.9d6c5b1b8c90c7861911be5409c1c69d.svg";
export { ForwardRef as ReactComponent };